import { Pipe, PipeTransform } from '@angular/core';
import { IBbitWebShopItemAttributeConfigurationItem, BbitArray } from '@bbitgmbh/bbit.utils';

@Pipe({ name: 'itemAttributeSort' })
export class ItemAttributeSortPipe implements PipeTransform {
  transform(
    value: IBbitWebShopItemAttributeConfigurationItem[] | undefined,
  ): IBbitWebShopItemAttributeConfigurationItem[] {
    if (!value || value.length === 0) {
      return [];
    }
    return BbitArray.sortBy(value, (o) => {
      return o.sortOrder;
    });
  }
}
